@if (showAsDialog) {
  <div class="modal-header">
    <h4 class="modal-title">{{ employee.firstName + ' ' + employee.lastName + "'s" + ' Schedule' }}</h4>
  </div>
}
<div class="page-content page-fill">
  @if (!showAsDialog) {
    <div>
      <button type="button" (click)="viewSchedule()" class="btn btn-secondary m-1" [disabled]="true">Print Giving Cause Sheet</button>
    </div>
  }
  @if (showAsDialog) {
    <div>
      <button type="button" (click)="closeDialog()" class="btn btn-secondary mb-2">Close</button>
    </div>
  }
  <div class="grid-fill offering-schedule" style="max-width: 1600px">
    <dx-scheduler
      #scheduler
      id="scheduler"
      [dataSource]="schedulerData"
      [views]="showAsDialog ? ['month'] : ['month', 'year']"
      [currentView]="showAsDialog ? 'month' : 'Year'"
      [currentDate]="currentDate"
      [firstDayOfWeek]="0"
      [startDayHour]="0"
      [endDayHour]="24"
      [height]="750"
      [showAllDayPanel]="true"
      [allDayExpr]="'allDay'"
      [editing]="false"
      (onAppointmentClick)="toolTip($event)"
      (onAppointmentDblClick)="onAppointmentDoubleClick($event)"
      (onAppointmentRendered)="setBackGroundColor($event)"
      (onCellContextMenu)="onCellContextMenu($event)"
      (onAppointmentContextMenu)="onAppointmentContextMenu($event)"
      (onContentReady)="onContentReady($event)"
      [appointmentTemplate]="!showAsDialog ? 'appointment-template' : ''"
      >
      <div *dxTemplate="let model of 'appointment-template'">
        @if (model?.appointmentData?.name) {
          <div>
            <div>
              <div>{{ model?.appointmentData?.aMOffering ? 'AM - ' : 'PM - ' }}{{ model?.appointmentData?.name }} {{model?.appointmentData?.amount ? ' - $' + model?.appointmentData?.amount.toFixed(2) : ''}}</div>
            </div>
          </div>
        }
      </div>
      <dxi-view name="Month" type="month" [intervalCount]="1"> </dxi-view>
      <dxi-view name="Year" type="month" [intervalCount]="12"> </dxi-view>
    </dx-scheduler>
    <dx-context-menu
      #appointmentMenu
      [dataSource]="appointmentContextMenuItems"
      target=".dx-scheduler-appointment"
      (onItemClick)="onContextMenuItemClick($event)"
      [width]="325"
    ></dx-context-menu>
    <dx-context-menu #cellMenu [dataSource]="cellContextMenuItems" target=".dx-scheduler-date-table-cell" (onItemClick)="onContextMenuItemClick($event)" [width]="200">
    </dx-context-menu>
  </div>
</div>
